import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import bus1 from "./Assets/bus1.png.jpeg"
import bus3 from "./Assets/bus3.png.jpeg"
import "./transOwner.css"
export default function TransOwnerDashLP() {
  const images = [bus1, bus3]
  
   
  
    return (
      <div className="flex flex-col h-[calc(100vh-80px)] w-full overflow-hidden carousel-image">
        <Carousel
          showThumbs={false}
          autoPlay
          infiniteLoop
          className="flex-grow max-h-full"
        >
          {images.map((imageDir, index) => (
            <div key={index} className="flex justify-center items-center w-full h-full overflow-hidden">
              <img
                src={imageDir}
                alt={`Slide ${index}`}
                className="object-cover w-full h-full max-h-[calc(100vh-80px)]"
              />
            </div>
          ))}
        </Carousel>
      </div>
    );
}